import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { ProducerTypes } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-dataset-no-data',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './dataset-no-data.component.html',
  styleUrls: ['./dataset-no-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetNoDataComponent {
  @Input() datasetViewUrl!: string;
  @Input() notebookViewUrl!: string;
  @Input() datasetProducerType = ProducerTypes.SqlQuery;

  get isNotebookCellDataset() {
    return this.datasetProducerType === ProducerTypes.NotebookCell;
  }
}
